import { AlternativeReadModel } from "@Alternatives/Alternatives/Domain/readmodels";
import { AlternativesViewType } from "@Alternatives/AlternativesViews/Domain/model";
import { AttributeReadModel } from "@Alternatives/Attributes/Domain/readmodels";
import { AlternativeStatusReadModel } from "@Alternatives/Statuses/Domain/readmodels";
import { DependentEntityInfo } from "@common/types";

export class ListsPageReadModel
{
    AlternativesListId: number;
    AlternativeLabel: string;
    AlternativesLabel: string;

    Views: AlternativesViewReadModel[];
    Statuses: AlternativeStatusReadModel[];
    Attributes: AttributeReadModel[];
    Alternatives: AlternativeReadModel[];
}

export class AlternativesViewReadModel
{
    Id: string;
    AlternativesListId: number;
    Name: string;
    Type: AlternativesViewType;
    AdvancedFilter: CompoundFilterReadModel;
    
    Included: string[];
    IsValid: boolean;
    IsStatic: boolean;
    IsPersisted: boolean;
}


export class AlternativeFilterReadModel 
{
    Type: string;
    Data: any;
    IsPropertyFilter: boolean;
    IsMemberFilter: boolean;
    IsStatusFilter: boolean;
    IsCompoundFilter: boolean;
    IsEdited: boolean;
}

export class CompoundFilterReadModel extends AlternativeFilterReadModel
{
    Filters: AlternativeFilterReadModel[];
}


export class ListDependenciesReadModel
{
    WorkspaceId: number;
    ProjectId: number;
    AlternativesListId: number;
    Id: string;
    Name: string;
    HasDependants: boolean;
    Count: number;
    Lists: DependentEntityInfo[];
    Reports: DependentEntityInfo[];
    EstimationsSurveys: DependentEntityInfo[];
}